export default __webpack_public_path__ + "static/4-2ce67106c7961c8021ce8056b8b8d167.jpg";